/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/editor/$projectId.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/editor/$projectId' | '/projects/$projectId' | '/projects/new' | '/projects'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/editor/$projectId' | '/projects/$projectId' | '/projects/new' | '/projects'
  id:
    | '__root__'
    | '/'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
